export default __webpack_public_path__ + "static/Festl_Tour_Impressionen_7-e7958293414c77bba4feb95f7ece71d0.jpg";